module.exports = __webpack_public_path__ + "img/malawi.8879cb6.webp";